export const priceCurrencyOptions = [
  { value: "GBP", label: "GPB" },
  { value: "NGN", label: "NGN" },
];
